import FilterDetails from './filter-details'
import FilterTable from './filter-table'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    FilterDetails.state,
    FilterTable.state
  ),
  mutations: Object.assign(
    FilterDetails.mutations,
    FilterTable.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/filters/index.js